import React, { useState } from "react";

const PoolsStandings = ({ pools }) => {
  const [selectedPool, setSelectedPool] = useState(null);

  const handlePanelToggle = (poolId) => {
    setSelectedPool((prevSelected) =>
      prevSelected === poolId ? null : poolId
    );
  };

  return (
    <div className="mb-2">
      {pools.map((pool) => (
        <div key={pool.pool_id} className="poolsStandingsList">
          <div
            className="d-flex justify-content-between align-items-center"
            onClick={() => handlePanelToggle(pool.pool_id)}
            style={{ backgroundColor: `#${pool.color_scheme}`, color: "#fff" }}
          >
            <h5>
              {pool.pool_name} ({pool.standings.length})
            </h5>
            <h5 style={{ textAlign: "right" }}>
              {selectedPool === pool.pool_id ? "▲" : "▼"}
            </h5>
          </div>

          <div
            className={`collapse ${
              selectedPool === pool.pool_id ? "show" : ""
            }`}
          >
            <ul className="list-group mt-2">
              {pool.standings.map((team) => (
                <li
                  key={team.event_registration_item_id}
                  className="list-group-item"
                >
                  {team.team_name} {team.city}, {team.state}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PoolsStandings;
